import { rpe2rir } from './science';
import { findExercise } from './exerciseDB';

export const HEVY_EN_TO_IT = {
  // Chest
  "bench press (barbell)":               "Distensioni su Panca Piana con Bilanciere",
  "bench press (dumbbell)":              "Distensioni su Panca Piana con Manubri",
  "bench press (smith machine)":         "Distensioni su Panca Piana alla Smith Machine",
  "incline bench press (barbell)":       "Distensioni su Panca Inclinata con Bilanciere",
  "incline bench press (dumbbell)":      "Distensioni su Panca Inclinata con Manubri",
  "incline bench press (smith machine)": "Distensioni su Panca Inclinata alla Smith Machine",
  "decline bench press (barbell)":       "Distensioni su Panca Declinata con Bilanciere",
  "decline bench press (dumbbell)":      "Distensioni su Panca Declinata con Manubri",
  "chest fly (dumbbell)":                "Flies con Manubri",
  "chest fly (cable)":                   "Flies al Cavo",
  "chest fly (machine)":                 "Flies alla Macchina",
  "incline chest fly (dumbbell)":        "Flies su Panca Inclinata con Manubri",
  "cable fly crossovers":                "Flies al Cavo",
  "single arm cable crossover":          "Flies al Cavo",
  // Back
  "lat pulldown (cable)":                "Lat Pull-Downs al Cavo Alto",
  "lat pulldown (machine)":              "Lat Pull-Downs alla Macchina",
  "seated cable row (cable)":            "Rematore al Cavo da Seduti",
  "seated cable row - bar grip":         "Rematore al Cavo da Seduti a Presa Larga",
  "cable row (cable)":                   "Rematore al Cavo da Seduti",
  "row (barbell)":                       "Rematore con Bilanciere",
  "barbell row (barbell)":               "Rematore con Bilanciere",
  "bent over row (barbell)":             "Rematore con Bilanciere",
  "row (dumbbell)":                      "Rematore a Una Mano con Manubrio",
  "dumbbell row (dumbbell)":             "Rematore a Una Mano con Manubrio",
  "iso-lateral low row":                 "Rematore alla Macchina da Seduti",
  "pulley basso":                        "Rematore al Cavo da Seduti",
  "pull up (bodyweight)":                "Trazioni alla Sbarra",
  "chin up (bodyweight)":                "Trazioni alla Sbarra a Presa Inversa",
  "face pull (cable)":                   "Trazioni al Volto al Cavo",
  "rear delt reverse fly (machine)":     "Flies Inversi alla Macchina",
  "pull-over (dumbbell)":                "Pull-Over con Manubrio",
  "pull-over (barbell)":                 "Pull-Over con Bilanciere",
  // Shoulders
  "overhead press (barbell)":            "Distensioni Anteriori Sopra la Testa con Bilanciere",
  "overhead press (dumbbell)":           "Distensioni Sopra la Testa con Manubri",
  "overhead press (smith machine)":      "Distensioni Anteriori Sopra la Testa alla Smith Machine",
  "shoulder press (dumbbell)":           "Distensioni Sopra la Testa con Manubri",
  "shoulder press (machine)":            "Distensioni Sopra la Testa alla Macchina",
  "lateral raise (dumbbell)":            "Alzate Laterali con Manubri",
  "lateral raise (cable)":               "Alzate Laterali al Cavo da Piegati",
  "lateral raise (machine)":             "Alzate Laterali alla Macchina",
  "front raise (dumbbell)":              "Alzate Frontali con Manubri",
  // Legs
  "squat (barbell)":                     "Squat con Bilanciere",
  "squat (smith machine)":               "Squat alla Smith Machine",
  "front squat (barbell)":               "Squat Frontali con Bilanciere",
  "hack squat (machine)":                "Hack Squat alla Macchina",
  "leg extension (machine)":             "Estensioni delle Gambe",
  "leg curl (machine)":                  "Flessioni delle Gambe da Seduti",
  "lying leg curl (machine)":            "Flessioni delle Gambe da Sdraiati",
  "seated leg curl (machine)":           "Flessioni delle Gambe da Seduti",
  "romanian deadlift (barbell)":         "Stacco Rumeno con Bilanciere",
  "romanian deadlift (dumbbell)":        "Stacco Rumeno con Manubri",
  "deadlift (barbell)":                  "Stacco con Bilanciere",
  "hip thrust (barbell)":                "Hip Thrust con Bilanciere",
  "hip thrust (machine)":                "Hip Thrust",
  "hip abduction (machine)":             "Abduzione della Gamba alla Macchina da Seduti",
  "leg press (machine)":                  "Leg Press alla Macchina",
  "calf raise (machine)":                "Alzate Polpacci alla Macchina in Piedi",
  "seated calf raise (machine)":         "Alzate Polpacci alla Macchina da Seduti",
  // Biceps
  "bicep curl (barbell)":                "Curls con Bilanciere",
  "bicep curl (dumbbell)":               "Curls con Manubri",
  "bicep curl (cable)":                  "Curls al Cavo Alto",
  "bicep curl (machine)":                "Preacher Curls alla Macchina",
  "hammer curl (dumbbell)":              "Curls a Martello",
  "preacher curl (barbell)":             "Preacher Curls con Bilanciere",
  "preacher curl (dumbbell)":            "Preacher Curls con Manubri",
  "reverse curl (dumbbell)":             "Curls Alternati con Manubri",
  "reverse curl (barbell)":              "Curls con Bilanciere a Presa Inversa",
  "rope cable curl":                     "Curls al Cavo Basso",
  // Triceps
  "triceps pushdown":                    "Tricipiti al Cavo",
  "tricep pushdown (cable)":             "Tricipiti al Cavo",
  "tricep pushdown (barbell)":           "Tricipiti al Cavo",
  "overhead tricep extension (cable)":   "French Presses al Cavo Basso in Piedi",
  "overhead tricep extension (dumbbell)":"Distensioni Sopra la Testa a Una Mano con Manubrio in Piedi",
  "skull crusher (barbell)":             "French Presses con Bilanciere da Sdraiati",
  "skull crusher (ez bar)":              "French Presses con Barra EZ da Sdraiati",
  "skullcrusher (barbell)":              "French Presses con Bilanciere da Sdraiati",
  "skullcrusher (dumbbell)":             "French Presses con Manubri da Sdraiati",
  "skullcrusher (ez bar)":               "French Presses con Barra EZ da Sdraiati",
  "dip (bodyweight)":                    "Dips alle Parallele",
  "dip (machine)":                       "Dips alla Macchina",
  // Core
  "crunch (machine)":                    "Crunches alla Macchina",
  // Italian Hevy names (when app is in Italian locale)
  // Hevy uses Italian parentheticals: (Macchina), (Cavo), (Bilanciere), (Manubri), (Smith Machine)
  "lento in avanti":                     "Distensioni Anteriori Sopra la Testa con Bilanciere",
  "lento in avanti (smith machine)":     "Distensioni Anteriori Sopra la Testa alla Smith Machine",
  "lento in avanti (bilanciere)":        "Distensioni Anteriori Sopra la Testa con Bilanciere",
  "lento in avanti (manubri)":           "Distensioni Sopra la Testa con Manubri",
  "panca piana":                         "Distensioni su Panca Piana con Bilanciere",
  "panca piana (bilanciere)":            "Distensioni su Panca Piana con Bilanciere",
  "panca piana (manubri)":               "Distensioni su Panca Piana con Manubri",
  "panca piana (manubrio)":              "Distensioni su Panca Piana con Manubri",
  "panca piana (smith machine)":         "Distensioni su Panca Piana alla Smith Machine",
  "panca piana (multipower)":            "Distensioni su Panca Piana alla Smith Machine",
  "panca inclinata":                     "Distensioni su Panca Inclinata con Bilanciere",
  "panca inclinata (bilanciere)":        "Distensioni su Panca Inclinata con Bilanciere",
  "panca inclinata (manubri)":           "Distensioni su Panca Inclinata con Manubri",
  "panca inclinata (manubrio)":          "Distensioni su Panca Inclinata con Manubri",
  "panca inclinata (smith machine)":     "Distensioni su Panca Inclinata alla Smith Machine",
  "panca inclinata (multipower)":        "Distensioni su Panca Inclinata alla Smith Machine",
  "panca declinata":                     "Distensioni su Panca Declinata con Bilanciere",
  "panca declinata (bilanciere)":        "Distensioni su Panca Declinata con Bilanciere",
  "panca declinata (manubri)":           "Distensioni su Panca Declinata con Manubri",
  "panca declinata (manubrio)":          "Distensioni su Panca Declinata con Manubri",
  "panca declinata (smith machine)":     "Distensioni su Panca Declinata alla Smith Machine",
  "panca declinata (multipower)":        "Distensioni su Panca Declinata alla Smith Machine",
  "squat":                               "Squat con Bilanciere",
  "squat (bilanciere)":                  "Squat con Bilanciere",
  "stacco":                              "Stacco con Bilanciere",
  "stacco (bilanciere)":                 "Stacco con Bilanciere",
  "stacco rumeno":                       "Stacco Rumeno con Bilanciere",
  "stacco rumeno (bilanciere)":          "Stacco Rumeno con Bilanciere",
  "rematore":                            "Rematore con Bilanciere",
  "rematore (bilanciere)":               "Rematore con Bilanciere",
  "rematore (manubrio)":                 "Rematore a Una Mano con Manubrio",
  "lat machine":                         "Lat Pull-Downs al Cavo Alto",
  "lat pulldown":                        "Lat Pull-Downs al Cavo Alto",
  "trazioni":                            "Trazioni alla Sbarra",
  "alzate laterali":                     "Alzate Laterali con Manubri",
  "alzate laterali (manubri)":           "Alzate Laterali con Manubri",
  "alzate laterali (cavo)":             "Alzate Laterali al Cavo da Piegati",
  "alzate laterali (macchina)":          "Alzate Laterali alla Macchina",
  // Chest flies (Italian Hevy names)
  "croci":                               "Flies con Manubri",
  "croci (manubri)":                     "Flies con Manubri",
  "croci (manubrio)":                    "Flies con Manubri",
  "croci (macchina)":                    "Flies alla Macchina",
  "croci (cavo)":                        "Flies al Cavo",
  "croci ai cavi":                       "Flies al Cavo Alto",
  "croci ai cavi (cavo)":               "Flies al Cavo Alto",
  "croci al cavo":                       "Flies al Cavo Alto",
  "croci al cavo alto":                  "Flies al Cavo Alto",
  "croci al cavo basso":                 "Flies al Cavo Basso",
  "croci inclinata (manubri)":           "Flies su Panca Inclinata con Manubri",
  "croci inclinata (manubrio)":          "Flies su Panca Inclinata con Manubri",
  // Biceps curls (Italian Hevy names)
  "curl":                                "Curls con Bilanciere",
  "curl (bilanciere)":                   "Curls con Bilanciere",
  "curl (manubri)":                      "Curls con Manubri",
  "curl (manubrio)":                     "Curls con Manubri",
  "curl bicipiti":                       "Curls con Manubri",
  "curl bicipiti (manubri)":             "Curls con Manubri",
  "curl bicipiti (manubrio)":            "Curls con Manubri",
  "curl bicipiti (bilanciere)":          "Curls con Bilanciere",
  "curl bicipiti (macchina)":            "Preacher Curls alla Macchina",
  "curl bicipiti (cavo)":                "Curls al Cavo Alto",
  "curl bicipiti con corda":             "Curls al Cavo Basso",
  "curl bicipiti con corda (cavo)":      "Curls al Cavo Basso",
  "curl con corda":                      "Curls al Cavo Basso",
  "curl con corda (cavo)":              "Curls al Cavo Basso",
  "curl invertito":                      "Curls con Bilanciere a Presa Inversa",
  "curl invertito (bilanciere)":         "Curls con Bilanciere a Presa Inversa",
  "curl invertito (manubri)":            "Curls con Bilanciere a Presa Inversa",
  "curl invertito (manubrio)":           "Curls con Bilanciere a Presa Inversa",
  "curl invertito (cavo)":               "Curls al Cavo Alto",
  "curl preacher":                       "Preacher Curls con Bilanciere",
  "curl preacher (bilanciere)":          "Preacher Curls con Bilanciere",
  "curl preacher (ez bar)":              "Preacher Curls con Barra EZ",
  "curl preacher (macchina)":            "Preacher Curls alla Macchina",
  "curl a martello":                     "Curls a Martello",
  "curl a martello (manubri)":           "Curls a Martello",
  "curl a martello (manubrio)":          "Curls a Martello",
  "french press":                        "French Presses con Bilanciere da Sdraiati",
  "french press (bilanciere)":           "French Presses con Bilanciere da Sdraiati",
  "french press (ez bar)":               "French Presses con Barra EZ da Sdraiati",
  "tricipiti al cavo":                   "Tricipiti al Cavo",
  "leg press":                           "Leg Press alla Macchina",
  "leg press (macchina)":               "Leg Press alla Macchina",
  "leg extension":                       "Estensioni delle Gambe",
  "leg extension (macchina)":           "Estensioni delle Gambe",
  "leg curl":                            "Flessioni delle Gambe da Seduti",
  "leg curl (macchina)":                "Flessioni delle Gambe da Seduti",
  "leg curl sdraiato":                  "Flessioni delle Gambe da Sdraiati",
  "leg curl sdraiato (macchina)":       "Flessioni delle Gambe da Sdraiati",
  "leg curl seduto":                    "Flessioni delle Gambe da Seduti",
  "leg curl seduto (macchina)":         "Flessioni delle Gambe da Seduti",
  "hack squat":                          "Hack Squat alla Macchina",
  "hack squat (macchina)":              "Hack Squat alla Macchina",
  "abduzione anche":                    "Abduzione della Gamba alla Macchina da Seduti",
  "abduzione anche (macchina)":         "Abduzione della Gamba alla Macchina da Seduti",
  "hip thrust":                          "Hip Thrust con Bilanciere",
  "hip thrust (bilanciere)":             "Hip Thrust con Bilanciere",
  "hip thrust (smith machine)":          "Hip Thrust alla Smith Machine",
  "alzate polpacci":                     "Alzate Polpacci alla Macchina in Piedi",
  "calf raise":                          "Alzate Polpacci alla Macchina in Piedi",
  "dip":                                 "Dips alle Parallele",
  "dips":                                "Dips alle Parallele",
  "crunch":                              "Crunches alla Macchina",
};

export function normalizeHevyName(title) {
  const key = title.toLowerCase().trim();
  if (HEVY_EN_TO_IT[key]) return HEVY_EN_TO_IT[key];
  const base = key.replace(/\s*\([^)]*\)\s*$/, "").trim();
  if (HEVY_EN_TO_IT[base]) return HEVY_EN_TO_IT[base];
  // Fallback: try fuzzy match against EXERCISE_DB (handles Italian Hevy names)
  const dbMatch = findExercise(base) || findExercise(title);
  return dbMatch ? dbMatch.name : title;
}

// ─── PARSER ───────────────────────────────────────────────────────────────────
const IT_MONTHS_SHORT = {gen:1,feb:2,mar:3,apr:4,mag:5,giu:6,lug:7,ago:8,set:9,ott:10,nov:11,dic:12};

function parseHevyDateLine(text) {
  // "Il giorno sabato, mag 23, 2026 alle ore 5:59pm"
  // Scan all word+number pairs to find one where the word is a month name
  const re = /(\w{3,})\s+(\d{1,2}),?\s+(\d{4})/gi;
  let m;
  while ((m = re.exec(text)) !== null) {
    const month = IT_MONTHS_SHORT[m[1].toLowerCase().slice(0,3)];
    if (month) return `${m[3]}-${String(month).padStart(2,'0')}-${String(m[2]).padStart(2,'0')}`;
  }
  return null;
}

export function parseHeavyNote(text) {
  if (!text?.trim()) return null;
  const lines=text.split("\n").map(l=>l.trim()).filter(Boolean);
  let date=new Date().toISOString().split("T")[0];

  // ISO date wins
  const isoM=text.match(/\d{4}-\d{2}-\d{2}/);
  if (isoM) { date=isoM[0]; }
  else {
    // Italian date from "Il giorno ..." line
    const dayLine=lines.find(l=>/^il giorno/i.test(l));
    if (dayLine) { const d=parseHevyDateLine(dayLine); if(d) date=d; }
  }

  // Workout name: explicit "Scheda: X" or first non-header line
  let workoutName="";
  const schedaLine=lines.find(l=>/^scheda:/i.test(l));
  if (schedaLine) {
    workoutName=schedaLine.replace(/^scheda:/i,"").trim();
  } else {
    // First line that is not a date/link/tag and doesn't look like a set
    const firstContent=lines.find(l=>
      !/^(il giorno|data:|note:|@\w|https?:\/\/)/i.test(l) &&
      !/serie\s*\d/i.test(l) &&
      l.length>1
    );
    if (firstContent) workoutName=firstContent;
  }

  const exercises=[]; let cur=null;
  for (const line of lines) {
    // Skip headers, links, social tags
    if (/^(scheda:|il giorno|data:|note:|@\w|https?:\/\/)/i.test(line)) continue;
    // Skip workout name line (already captured)
    if (workoutName && line===workoutName && !cur) continue;

    // Serie line — RPE is optional
    const sm=line.match(/serie\s*\d+\s*:\s*([\d.]+)\s*kg\s*[x×ex]\s*(\d+)(?:\s*@\s*([\d.]+)\s*rpe?)?/i);
    if (sm&&cur){
      cur.sets.push({weight:sm[1],reps:sm[2],rpe:sm[3]||"",rir:sm[3]?String(rpe2rir(sm[3])):""});
      continue;
    }
    // Skip malformed set lines (contain "serie" but didn't match above)
    if (/^serie\s*\d/i.test(line)) continue;

    // Quoted note line → attach to current exercise
    const noteMatch = line.match(/^[""](.+)[""]$/) || line.match(/^"(.+)"$/);
    if (noteMatch && cur) {
      cur.note = noteMatch[1];
      continue;
    }

    // Exercise name line
    if (line.length > 1) {
      if (cur&&cur.sets.length>0) exercises.push(cur);
      const rawName=line.replace(/\(.*?\)/g,"").trim();
      const mach=(line.match(/\((.*?)\)/)||[])[1]||"";
      // Try HEVY_EN_TO_IT map first (handles both English and Italian Hevy names),
      // then fall back to fuzzy DB match
      const normalized=normalizeHevyName(line);
      const _dbEx=normalized!==line?findExercise(normalized):null
        ||findExercise(rawName)
        ||findExercise(line);
      const name=_dbEx?_dbEx.name:(normalized!==line?normalized:rawName);
      cur={name,machine:mach,note:"",
        type:_dbEx?_dbEx.type:(/(squat|press|panca|lento|rematore|stacco|leg press|lat machine|low row|pulley|french|push|pulldown)/i.test(name)?"compound":"isolation"),
        primaryMuscle:_dbEx?.primaryMuscle||null,
        muscles:_dbEx?.muscles||[],
        sets:[]};
    }
  }
  if (cur&&cur.sets.length>0) exercises.push(cur);
  if (!exercises.length) return null;
  return {date,workoutName,exercises};
}

// ─── HEVY CSV PARSER ─────────────────────────────────────────────────────────
export const IT_MONTHS = {gen:1,feb:2,mar:3,apr:4,mag:5,giu:6,lug:7,ago:8,set:9,ott:10,nov:11,dic:12};

export function parseItalianDate(str) {
  const m = (str||"").trim().match(/^(\d+)\s+(\w+)\s+(\d{4})/);
  if (!m) return null;
  const month = IT_MONTHS[m[2].toLowerCase()];
  if (!month) return null;
  return `${m[3]}-${String(month).padStart(2,"0")}-${String(m[1]).padStart(2,"0")}`;
}

function parseHevyStartTime(raw) {
  const italian = parseItalianDate(raw);
  if (italian) return italian;
  // Hevy exports English format: "May 18, 2026, 5:47 PM"
  const d = new Date(raw);
  if (!isNaN(d)) return d.toISOString().split("T")[0];
  return null;
}

export function parseCSVRow(line) {
  const fields=[]; let i=0,f="";
  while(i<=line.length){
    if(i===line.length||line[i]===","){fields.push(f);f="";i++;}
    else if(line[i]==='"'){
      i++;
      while(i<line.length){
        if(line[i]==='"'&&line[i+1]==='"'){f+='"';i+=2;}
        else if(line[i]==='"'){i++;break;}
        else f+=line[i++];
      }
      if(i<line.length&&line[i]===",")i++;
      fields.push(f);f="";
    } else { while(i<line.length&&line[i]!==",")f+=line[i++]; }
  }
  return fields;
}

export function parseHevyCSV(text) {
  const lines=(text||"").trim().split(/\r?\n/).filter(Boolean);
  if(lines.length<2) return null;
  const headers=parseCSVRow(lines[0]);
  const idx={};
  headers.forEach((h,i)=>{idx[h.replace(/"/g,"").trim()]=i;});
  const required=["title","start_time","exercise_title","weight_kg","reps"];
  if(required.some(k=>idx[k]===undefined)) return null;

  const sessionMap=new Map();
  for(let li=1;li<lines.length;li++){
    const cols=parseCSVRow(lines[li]);
    const title=cols[idx.title]||"";
    const startTime=cols[idx.start_time]||"";
    const key=`${title}|||${startTime}`;
    if(!sessionMap.has(key)){
      sessionMap.set(key,{
        id:Date.now()+li*7,
        date:parseHevyStartTime(startTime)||new Date().toISOString().split("T")[0],
        workoutName:title,
        exercises:[],
        _exMap:new Map(),
      });
    }
    const sess=sessionMap.get(key);
    const exTitle=cols[idx.exercise_title]||"";
    if(!exTitle) continue;
    const weight=parseFloat(cols[idx.weight_kg])||0;
    const reps=parseInt(cols[idx.reps])||0;
    if(!weight&&!reps) continue;
    const rpeRaw=cols[idx.rpe]!=null?parseFloat(cols[idx.rpe]):NaN;
    const rpeStr=isNaN(rpeRaw)||rpeRaw===0?"":String(rpeRaw);
    const exNote=cols[idx.exercise_notes]||"";
    if(!sess._exMap.has(exTitle)){
      const normalizedName=normalizeHevyName(exTitle);
      const dbEx=findExercise(normalizedName);
      const exObj={name:normalizedName,type:dbEx?dbEx.type:"compound",
        primaryMuscle:dbEx?.primaryMuscle||null,muscles:dbEx?.muscles||[],
        note:exNote,sets:[]};
      sess._exMap.set(exTitle,exObj);
      sess.exercises.push(exObj);
    }
    const ex=sess._exMap.get(exTitle);
    if(exNote&&!ex.note) ex.note=exNote;
    ex.sets.push({weight:String(weight),reps:String(reps),rpe:rpeStr,rir:rpeStr?String(rpe2rir(rpeStr)):""});
  }
  const sessions=[];
  for(const s of sessionMap.values()){
    delete s._exMap;
    if(s.exercises.length>0) sessions.push(s);
  }
  return sessions.length?sessions.sort((a,b)=>a.date.localeCompare(b.date)):null;
}

